export const normalizeWhatsAppE164 = (value) => {
  const text = String(value || "").trim();
  if (!/^\+?[\d\s().-]+$/.test(text)) return "";
  const digits = text.replace(/\D/g, "");
  return /^[1-9]\d{7,14}$/.test(digits) ? `+${digits}` : "";
};

export const readWhatsAppPhoneEntry = (callingCode, nationalNumber) => {
  const code = String(callingCode || "").trim().replace(/^\+/, "");
  const text = String(nationalNumber || "").trim();
  if (!/^[1-9]\d{0,2}$/.test(code) || !/^\+?[\d\s().-]+$/.test(text)) {
    throw new Error("Ingresa el codigo de pais y un numero de WhatsApp valido.");
  }
  let number = text.replace(/\D/g, "");
  if (text.startsWith("+")) {
    if (!number.startsWith(code)) throw new Error("El numero no coincide con el codigo de pais elegido.");
    number = number.slice(code.length);
  }
  if (code === "54") {
    number = number.replace(/^0/, "");
    // Argentina may include the mobile 9 in the international representation.
    if (/^9\d{10}$/.test(number)) number = number.slice(1);
    if (!/^[1-9]\d{9}$/.test(number)) {
      throw new Error("Ingresa codigo de area y numero, sin 0 ni 15. Ejemplo: 1112345678.");
    }
  }
  const expectedPhone = normalizeWhatsAppE164(`+${code}${number}`);
  if (!expectedPhone || number.length < 6) throw new Error("Revisa el numero de WhatsApp del local.");
  return { expectedPhone, phone: { code: Number(code), number } };
};

export const matchesWhatsAppPhone = (expected, actual) => {
  const canonical = (value) => {
    const normalized = normalizeWhatsAppE164(value);
    return normalized.replace(/^\+549(\d{10})$/, "+54$1");
  };
  const expectedNormalized = canonical(expected);
  return Boolean(expectedNormalized && expectedNormalized === canonical(actual));
};

export const assertWhatsAppPhoneMatch = (expected, actual) => {
  if (!matchesWhatsAppPhone(expected, actual)) {
    throw new Error("El numero autorizado en Meta no coincide con el que ingresaste. No se cambio la conexion del local. Volve a vincular y selecciona el mismo numero.");
  }
};
